import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { System } from '../../../shared-components/System';
import { LoginService } from '../../../shared-modules/login/login.service';
import { FamilyRegistrationService } from '../family-registration.service';
import { UserService } from '../../../shared-components/user/user.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../../shared-components/translation/translation.service';
import { FamilyRegistrationYear } from '../../family-registration/family-registration-year.model';
import { NewFamilyRegistrationYearSelectionComponent } from '../../family-registration/new-family-registration-year-selection/new-family-registration-year-selection.component';
import { Router } from '@angular/router';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { SharedService } from '../../../shared-components/shared.service';
import { EmailNotSentComponent } from '../email-not-sent/email-not-sent.component';
import { EmailSentComponent } from '../email-sent/email-sent.component';

@Component({
  selector: 'app-register-new-family-verify-code',
  templateUrl: './register-new-family-verify-code.component.html',
  styles: [
  ]
})
export class RegisterNewFamilyVerifyCodeComponent implements OnInit {

  @ViewChild('email', { static: true }) inputEmail: ElementRef;
  @ViewChild('code', { static: true }) inputCode: ElementRef;
  registerNewFamily: any;
  public errorList: ErrorList[] = [];
  dialogWidth: number;
  @ViewChild('dialogWindow', { read: ElementRef }) dialogWindow: ElementRef;
  frYearsDialogRef: MatDialogRef<NewFamilyRegistrationYearSelectionComponent>;


  constructor(
    private familyRegistrationService: FamilyRegistrationService,
    private dialogRef: MatDialogRef<RegisterNewFamilyVerifyCodeComponent>,
    private loginService: LoginService,
    private dialog: MatDialog,
    private userService: UserService,
    private translateService: TranslateService,
    private translationService: TranslationService,
    private router: Router,
    private sharedService: SharedService
  ) { }

  verifyEmail: string;
  verifyCode: string;
  isValid: boolean;
  V10 = false;

  languageId = 1;

  ngOnInit(): void {
    // this.registerNewFamily = this.familyRegistrationService.registerNewFamily;
    this.V10 = this.loginService.LoginSettings.V10;
  }

  modalInstanceNextClick() {
    if (this.validate()) {
      this.loginService.getRegisterParentInfo(this.verifyEmail, this.verifyCode).subscribe(
        (result) => {
          if (result) {
            // this.location.url(this.location.path());
            this.familyRegistrationService.students = [];
            this.familyRegistrationService.householdParent = result;
            if (this.familyRegistrationService.householdParent.Id == -1) {
              this.invalidCombination();
            }
            else if (this.familyRegistrationService.householdParent.Id == -2) {
              // Expired
              this.codeExpire();
              this.dialogRef.close('Closed.');

            }
            else if (this.familyRegistrationService.householdParent.Id > 0) {
              this.dialogRef.close('Next was clicked.');
              this.redirectQR();
            }

          }
        }
      );
    }
  }


  invalidCombination() {
    const invalidCodeDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    invalidCodeDialog.componentInstance.headerLabel = 'Invalid Email/Code Combination';
    invalidCodeDialog.componentInstance.confirmMessage = 'The code provided is not associated with this email address.';
    invalidCodeDialog.componentInstance.disableConfirmation = true;
    invalidCodeDialog.componentInstance.confirmEvent.subscribe((invalidCodeReturnValue: boolean) => {
      // if (invalidCodeReturnValue) {
      //   // close button no need to do anything
      // }
    });
  }


  codeExpire() {

    const m1 = this.translateService.instant('The code you entered has expired.');
    const m2 = this.translateService.instant('Would you like to have a new code sent to');
    const codeExpiredDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    codeExpiredDialog.componentInstance.headerLabel = 'Expired Code';
    codeExpiredDialog.componentInstance.confirmMessage = m1;
    codeExpiredDialog.componentInstance.secondMessage = m2 + ' ' + this.verifyEmail + '?';
    codeExpiredDialog.componentInstance.okButtonLabel = 'Yes';
    codeExpiredDialog.componentInstance.cancelButtonLabel = 'No';
    codeExpiredDialog.componentInstance.okButtonLabel = 'Yes';
    codeExpiredDialog.componentInstance.cancelButtonLabel = 'No';
    codeExpiredDialog.afterClosed().subscribe((resendEmail: boolean) => {
      if (resendEmail) {
        this.familyRegistrationService.sendRegisterParentEmail(this.verifyEmail, this.languageId, '').subscribe(
          (result) => {
            if (!result) {
              const emailNotSentDialog = this.dialog.open(EmailNotSentComponent, {
                panelClass: 'tyl-mat-dialog',
              });
            }
            else {
              const data: any = { languageId: this.languageId,  emailAddress: this.verifyEmail};
              this.dialog.open(EmailSentComponent, {
                panelClass: 'tyl-mat-dialog',
                data: {
                  registerNewFamily : data
                }
              });
            }
          },
          () => {
            const emailNotSentDialog = this.dialog.open(EmailNotSentComponent, {
              panelClass: 'tyl-mat-dialog',
            });
          }
        );

      }
      else {
        this.loginService.resetLanguage.emit(true);
      }
    });
  }


  redirectQR() {
    this.userService.currentLanguage = 'en';
    if (this.familyRegistrationService.householdParent.Language == 2) {
      this.userService.currentLanguage = 'fr';
    } else if (this.familyRegistrationService.householdParent.Language == 3) {
      this.userService.currentLanguage = 'es';
    } else if (this.familyRegistrationService.householdParent.Language == 4) {
      this.userService.currentLanguage = 'pt';
    }

    this.translateService.use(this.userService.currentLanguage);
    this.translateService.setDefaultLang(this.userService.currentLanguage);
    this.translationService.getLanguageTranslations();

    this.familyRegistrationService.getORYears().subscribe((years: FamilyRegistrationYear[]) => {
      this.familyRegistrationService.years = years;
      if (this.familyRegistrationService.years.length != 0) {
        if ((this.loginService.LoginSettings.V10 && this.familyRegistrationService.householdParent.AyIdentifier != null && this.familyRegistrationService.householdParent.AyIdentifier != '') || (!this.loginService.LoginSettings.V10 && this.familyRegistrationService.householdParent.YearId > 0)) {
          if (this.loginService.LoginSettings.V10) {
            this.familyRegistrationService.defaultYear = this.familyRegistrationService.years.find(o => o.AYIdentifier == this.familyRegistrationService.householdParent.AyIdentifier);
          } else {
            this.familyRegistrationService.defaultYear = this.familyRegistrationService.years.find(o => o.Id == this.familyRegistrationService.householdParent.YearId);
          }
          if (this.familyRegistrationService.defaultYear) {
            this.router.navigateByUrl('/familyregistration/householdparent');
          }
        } else {
          if (this.loginService.LoginSettings.V10) {
            const currentDate = new Date();
            for (let i = 0; i < this.familyRegistrationService.years.length; i++) {
              if (this.familyRegistrationService.years[i].Status == 1) {
                if (this.familyRegistrationService.years[i].StartDate < currentDate) {
                  this.familyRegistrationService.years[i].Status = 3;
                }
              }
            }
          }

          if (this.familyRegistrationService.years.length > 1) {
            this.frYearsDialogRef = this.dialog.open(NewFamilyRegistrationYearSelectionComponent, {
              disableClose: true,
              maxWidth: '500px'
            });
          } else {
            this.familyRegistrationService.defaultYear = this.familyRegistrationService.years[0];
            this.familyRegistrationService.householdParent.YearId = this.familyRegistrationService.defaultYear.Id;
            this.familyRegistrationService.householdParent.AyIdentifier = this.loginService.LoginSettings.V10 ? this.familyRegistrationService.defaultYear.AYIdentifier : this.familyRegistrationService.defaultYear.Description;

            this.frYearsDialogRef = this.dialog.open(NewFamilyRegistrationYearSelectionComponent, {
              disableClose: true,
              maxWidth: '500px'
            });
          }
        }
      }
    });
  }

  validate(): boolean {
    const mailformat = System.mailRegexp;
    this.errorList = [];
    this.isValid = true;
    if (this.verifyEmail == null || this.verifyEmail == '') {
      this.errorList.push({
        fieldName: 'Email',
        fieldRef: this.inputEmail,
        errorMsg: 'Field is required'
      });
      this.isValid = false;
    }
    else if (this.verifyEmail.match(mailformat) == null) {
      this.errorList.push({
        fieldName: 'Email',
        fieldRef: this.inputEmail,
        errorMsg: 'Invalid Email Address'
      });
      this.isValid = false;
    }
    if (this.verifyCode == null || this.verifyCode == '') {
      this.errorList.push({
        fieldName: 'Code',
        fieldRef: this.inputCode,
        errorMsg: 'Field is required'
      });
      this.isValid = false;
    }
    return this.isValid;
  }
  modalInstanceCancelClick() {
    this.dialogRef.close('Cancel was clicked.');
    this.loginService.resetLanguage.emit(true);
  }

}
